module.exports = __webpack_public_path__ + "static/media/circle9.152463c6.svg";